import { CSSProperties } from 'react';
import { theme } from '../../theme';

const font = theme.typography.fontFamily;

export const paymentSuccessPanelStyles = {
  panel: {
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: 480,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing.medium,
    padding: `${theme.spacing.extraLarge}px ${theme.spacing.large}px`,
    backgroundColor: theme.colors.white,
    border: '1px solid #E8E8E8',
    borderRadius: theme.radius.md,
  } as CSSProperties,

  iconWrapper: {
    marginTop: theme.spacing.small,
  } as CSSProperties,

  title: {
    margin: 0,
    maxWidth: 420,
    textAlign: 'center',
    color: theme.colors.palette.darkGrey200,
    fontFamily: font,
    fontSize: theme.typography.fontSize.lg,
    fontWeight: theme.typography.fontWeight.bold,
    lineHeight: theme.typography.lineHeight.lg,
  } as CSSProperties,

  lead: {
    margin: 0,
    maxWidth: 420,
    textAlign: 'center',
    color: theme.colors.label,
    fontFamily: font,
    fontSize: theme.typography.fontSize.sm,
    lineHeight: theme.typography.lineHeight.sm,
  } as CSSProperties,

  orderLine: {
    margin: 0,
    maxWidth: 420,
    textAlign: 'center',
    color: theme.colors.palette.darkGrey200,
    fontFamily: font,
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.medium,
    lineHeight: theme.typography.lineHeight.sm,
  } as CSSProperties,

  redirecting: {
    margin: 0,
    maxWidth: 420,
    textAlign: 'center',
    color: theme.colors.palette.darkGrey100 ?? theme.colors.label,
    fontFamily: font,
    fontSize: theme.typography.fontSize.sm,
    lineHeight: theme.typography.lineHeight.sm,
  } as CSSProperties,
};
